import _classCallCheck from "/Users/benn/Dropbox/Mon Mac (MacBook-Pro.local)/Documents/Work/Personal Website/personal-site/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/benn/Dropbox/Mon Mac (MacBook-Pro.local)/Documents/Work/Personal Website/personal-site/node_modules/@babel/runtime/helpers/esm/createClass";
import Color from './model/Color';
import ColorSpace from './model/ColorSpace';

var ColorMixer = /*#__PURE__*/function () {
  function ColorMixer() {
    _classCallCheck(this, ColorMixer);

    this.gradient = [{
      reference: 0,
      color: {
        red: 0,
        green: 0,
        blue: 0
      }
    }, {
      reference: 100,
      color: {
        red: 255,
        green: 255,
        blue: 255
      }
    }];
    return this;
  }

  _createClass(ColorMixer, [{
    key: "mix",
    value: function mix(colors, percents) {
      if (typeof colors == 'undefined' || Object.prototype.toString.call(colors) != '[object Array]') {
        throw new Error('"ColorMixer.mix()" first parameter should be an array of ColorMixer.Color objects');
      }

      if (typeof percents == 'undefined') {
        percents = [];
        var _i = colors.length;

        while (_i--) {
          percents[_i] = 100 / colors.length;
        }
      } else if (Object.prototype.toString.call(percents) != '[object Array]') {
        throw new Error('"ColorMixer.mix()" second parameter should be an array of percents. (nnumber values)');
      }

      if (colors.length != percents.length) {
        throw new Error('"ColorMixer.mix()" parameters should be arrays of the same size !');
      }

      var i = colors.length;
      var L = 0;
      var a = 0;
      var b = 0;
      var P = 0;

      while (i--) {
        if (!(colors[i] instanceof Color)) {
          throw new Error('"ColorMixer.mix()" color at index: ' + i + ' should be an instance of ColorMixer.Color() object !');
        }

        P += percents[i];

        if (P > 100) {
          throw new Error('Invalid "ColorMixer.mix()" second parameter: the sum of all the percents array items should be 100.');
        }

        var Lab = ColorSpace.RGBtoLab(colors[i].getRed(), colors[i].getGreen(), colors[i].getBlue());
        L += Lab.L * percents[i] / 100;
        a += Lab.a * percents[i] / 100;
        b += Lab.b * percents[i] / 100;
      }

      if (P != 100) {
        throw new Error('Invalid "ColorMixer.mix()" second parameter: the sum of all the percents array items should be 100.');
      }

      var RGB = ColorSpace.LabtoRGB(L, a, b);
      return new Color(RGB.red, RGB.green, RGB.blue);
    }
  }, {
    key: "setGradient",
    value: function setGradient(newGradient) {
      if (typeof newGradient != 'undefined' && Object.prototype.toString.call(newGradient) == '[object Array]') {
        this.gradient = newGradient;
      }

      return this;
    }
  }, {
    key: "getGradient",
    value: function getGradient() {
      return this.gradient;
    }
  }, {
    key: "blend",
    value: function blend(reference) {
      if (typeof reference == 'undefined') {
        throw new Error('Missing "ColorMixer.blend()" first parameter.');
      }

      reference = parseInt(reference);

      if (isNaN(reference)) {
        throw new Error('Invalid "ColorMixer.blend()" first parameter: you should provide a number.');
      }

      var l = this.gradient.length;
      var previous = this.gradient[0];
      var next = this.gradient[l - 1]; // Get the color range (the closest steps of reference in the gradient)

      if (reference <= previous.reference) {
        return new Color(previous.color.red, previous.color.green, previous.color.blue);
      } else if (reference >= next.reference) {
        return new Color(next.color.red, next.color.green, next.color.blue);
      }

      while (l--) {
        var step = this.gradient[l];

        if (step.reference <= reference && step.reference > previous.reference) {
          previous = step;
        } else if (step.reference >= reference && step.reference < next.reference) {
          next = step;
        }
      }

      var C1 = new Color(previous.color.red, previous.color.green, previous.color.blue);
      var C2 = new Color(next.color.red, next.color.green, next.color.blue); // Calculate percentages

      previous.percent = Math.abs(100 / ((previous.reference - next.reference) / (reference - next.reference)));
      next.percent = 100 - previous.percent; // Mix the colors on LAB Color Space
      // Then convert it to RGB again
      // Returns a ColorMixer.Color instance.

      return this.mix([C1, C2], [previous.percent, next.percent]);
    }
  }]);

  return ColorMixer;
}();

var instance = new ColorMixer();
export default instance;